/*
 * This is the entry point for the store.
 * Create a new module for your store object
 */
import Vue from 'vue'
import Vuex from 'vuex'
import cartStorage from './plugins/cartStorage'

Vue.use(Vuex)

const files = require.context('./', true, /^\.\/.*\.js$/)
const filenames = files.keys()

function getModule (filename) {
  let file = files(filename)
  return file.default
    ? file.default
    : file
}

function getModuleNamespace (storeData, namePath) {
  if (namePath.length === 1) return storeData.modules

  const namespace = namePath.shift()

  storeData.modules[namespace] = storeData.modules[namespace] || {}
  storeData.modules[namespace].namespaced = true
  storeData.modules[namespace].modules = storeData.modules[namespace].modules || {}

  return getModuleNamespace(storeData.modules[namespace], namePath)
}

let store
let storeData = {}

// Generate the store from all the modules inside the store folder
storeData.modules = storeData.modules || {}
for (let filename of filenames) {
  let name = filename.replace(/^\.\//, '').replace(/\.js$/, '')
  if (name === 'index') continue

  let namePath = name.split(/\//)
  let module = getModuleNamespace(storeData, namePath)

  name = namePath.pop()
  module[name] = getModule(filename)
  module[name].namespaced = true
}

// Plugins
storeData.plugins = storeData.plugins || []
storeData.plugins.push(cartStorage())

store = new Vuex.Store(storeData)

export default store



// WEBPACK FOOTER //
// ./client/store/index.js